export default __webpack_public_path__ + "static/unique_back-ca9b59c6125477af881ecad1e71ffb09.webp";